import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const IamListPage = () =>
  import('@modules/iam/components/iam-list-page.vue');
const IamNewPage = () =>
  import('@modules/iam/components/iam-new-page.vue');
const IamEditPage = () =>
  import('@modules/iam/components/iam-edit-page.vue');
const IamViewPage = () =>
  import('@modules/iam/components/iam-view-page.vue');
const IamImporterPage = () =>
  import('@modules/iam/components/iam-importer-page.vue');
const CoachFormPage = () =>
  import('@modules/coach/components/coach-form-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        props: true,
        name: 'iam',
        path: '/iam/:tabName?',
        component: IamListPage,
        meta: {
          auth: true,
          permission: Permissions.values.iamRead,
        },
      },
      {
        name: 'iamNew',
        path: '/iam/managers/new',
        component: IamNewPage,
        meta: {
          auth: true,
          permission: Permissions.values.iamCreate,
        },
      },
      {
        name: 'iamImporter',
        path: '/iam/import',
        component: IamImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.iamImport,
        },
      },
      {
        name: 'iamEdit',
        path: '/iam/managers/:id/edit',
        component: IamEditPage,
        meta: {
          auth: true,
          permission: Permissions.values.iamEdit,
        },
        props: true,
      },
      {
        name: 'iamView',
        path: '/iam/:id',
        component: IamViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.iamRead,
        },
        props: true,
      },
      {
        name: 'iamCoachNew',
        path: 'iam/coach/new',
        component: CoachFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.coachCreate,
        },
      },
      {
        name: 'iamCoachEdit',
        path: 'iam/coaches/:id/edit',
        component: CoachFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.coachEdit,
        },
        props: true,
      },
    ],
  },
];
